import CompanyStatus from './CompanyStatus';

export default CompanyStatus;